import UserProfile from "./UserProfile"
import UserProfileForm from "./UserProfileForm"

const Profile = () => {
  if(window.configs.showStudentEditDetailForm){
    return (
        <UserProfileForm/>    
    )
  }else{
    return (
      <UserProfile/>    
    )
  }
}

export default Profile